import utils from '@/mixins/utils.js'

/**
 * Verifica pendências baseada nos alertas da TabelaCadastros.vue
 *
 * @param {Object} item
 * @returns {String}
 */
function verificarPendencias(item) {
  const pendencias = []

  // Primeira consulta (a_pb)
  if (item.a_pb == null || item.a_pb == 0) {
    pendencias.push('Primeira consulta')
  }

  // Consultas (b_pb)
  if (item.b_pb == null || item.b_pb == 0) {
    pendencias.push('Consultas')
  }

  // Peso e altura (c_pb)
  if (item.c_pb == null || item.c_pb == 0) {
    pendencias.push('Peso e altura')
  }

  // Visitas (d_pb)
  if (item.d_pb == null || item.d_pb == 0) {
    pendencias.push('Visitas')
  }

  // Vacinas (e_pb)
  if (item.e_pb == null || item.e_pb == 0) {
    pendencias.push('Vacinas')
  }

  return pendencias.length > 0 ? pendencias.join(', ') : ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(
        item.dt_nascimento
      )} (${Math.floor(item.idade_dias / 30)} ${
        Math.floor(item.idade_dias / 30) > 1 ? 'meses' : 'mês'
      })`
      return idade
    },
  },
  Mãe: 'no_mae',
  Microárea: 'micro_area',
  Pendências: {
    callback: (item) => {
      return verificarPendencias(item)
    },
  },
}

export const infoHtml = ``

export const optionsFilterBoasPraticas = [
  {
    label: 'Todas',
    value: null,
    key: 'todas',
    key_percentual: 'todas',
  },
  {
    label: 'Primeira consulta',
    value: 'a_pb',
    key: 'primeira-consulta',
    key_percentual: 'fai_1consulta',
  },
  {
    label: 'Consultas',
    value: 'b_pb',
    key: 'consultas',
    key_percentual: 'fai',
  },
  {
    label: 'Peso e altura',
    value: 'c_pb',
    key: 'peso-altura',
    key_percentual: 'pes_alt',
  },
  {
    label: 'Visita ACS/TACS',
    value: 'd_pb',
    key: 'visitas',
    key_percentual: 'fvdt',
  },
  {
    label: 'Vacinas',
    value: 'e_pb',
    key: 'vacinas',
    key_percentual: 'vac',
  },
]
